export enum OrderStatus {
  pending = "pending",
  preparing = "preparing",
  delivering = "delivering",
  delivered = "delivered",
  canceled = "canceled",
  failed = "failed",
}

export enum OrderDeliveryMethods {
  standard = "standard",
  nextDay = "nextDay",
  nominated = "nominated",
}
